import type { HRModule } from '@bc-library/interface'

export const HR_SETTING_ACCESS_KEYS = [
  'settingsDepartureCategoryAccess',
  'settingsDegreeFieldCategoryAccess',
  'settingsEmployeeVariablesAccess',
  'settingsStatusAccess',
  'settingsContractSuperTypesAccess',
  'settingsContractTypesAccess',
  'settingsOnboardingProcessAccess',
  'settingsMailTemplatesAccess',
  'settingsFirmNewsAccess',
  'settingsSignatureTemplatesAccess',
  'settingsResourceCreationFieldsAccess',
] as const

export type HrSettingAccessKey = typeof HR_SETTING_ACCESS_KEYS[number]

// Signature templates only exist with e-signature: without it, that right alone opens an empty page
export const hasAnyHrSettingsAccess = (hr?: HRModule, hasESignature = true) => {
  if (!hr)
    return false
  if (hr.settingsAccess)
    return true
  return HR_SETTING_ACCESS_KEYS.some(key => hr[key] && (hasESignature || key !== 'settingsSignatureTemplatesAccess'))
}

export const hasHrSettingAccess = (
  hr: HRModule | undefined,
  key: HrSettingAccessKey,
) => {
  if (!hr)
    return false
  if (hr.settingsAccess)
    return true
  return !!hr[key]
}
